import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { ContractconversionService } from 'src/app/Services/contractconversion.service';
import { CustomerService } from 'src/app/Services/customer.service';
import { ExportUtility } from 'src/assets/js/export-utility';

@Component({
  selector: 'app-v-prequotecontractconversion',
  templateUrl: './v-prequotecontractconversion.component.html',
  styleUrls: ['./v-prequotecontractconversion.component.css']
})
export class VPrequotecontractconversionComponent implements OnInit {
  ContractConversionCustomersList: any[]
  CustomerList: any[]
  cols: any[];
  sessionId: string
  _UserName: string
  _RoleName: string
  constructor(private router: Router, private _CustomerService: CustomerService, private _CustomExceptionService: CustomExceptionService,private _ContractconversionService: ContractconversionService,
    public exportUtility: ExportUtility, private route: ActivatedRoute,) { }

  ngOnInit(): void {

    this._ContractconversionService.GetPageInitializeDetails().subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log("signoffpageload", resultJSON);
      this.ContractConversionCustomersList = resultJSON.lstCustomerSite
      // this._CustomerApprovedList = resultJSON.lstCustomerSite
    }, error => { this._CustomExceptionService.handleError(error) }
    );

    // this._ContractconversionService.GetById(this.customersiteCode).subscribe((result) => {

    //   const resultJSON = JSON.parse(JSON.stringify(result));
    //   // console.log("signoffid", resultJSON);
    //   if (resultJSON.prequoteContractConversionDetail != null || resultJSON.prequoteContractConversionDetail != null) {
    //     this.ExistConversionList = resultJSON.prequoteContractConversionDetail
    //     this.CommissionConfigList = resultJSON.prequoteContractConversionDetail.lstBookingCommission
    //     this.OtherChargesList = resultJSON.prequoteContractConversionDetail.lstAddOnCommission

    //     this.creditassessmentsurl = resultJSON.prequoteContractConversionDetail.creditassessmentscoresheetURL
    //     this.creditworthinessurl = resultJSON.prequoteContractConversionDetail.creditworthinessdocumentURL
    //     this._ConversionForm.setValue(resultJSON.prequoteContractConversionDetail);
        
    //   }
    //   else{
    //     if(this.CommissionConfigList.length == 0)
    //     {
    //       this.CommissionConfigList = [
    //         { bookingcommissionslabid : "0", customersitecode : this.customersiteCode, belowcardratefrom : "90", belowcardrateto : "100", commissionpercentage : "12", recordstatus : "MSC00001", recordstatuscode : "MSC00001",isdisabledremove:true},
    //         { bookingcommissionslabid : "0", customersitecode : this.customersiteCode, belowcardratefrom : "80", belowcardrateto : "89.99", commissionpercentage : "10", recordstatus : "MSC00001", recordstatuscode : "MSC00001",isdisabledremove:true},
    //         { bookingcommissionslabid : "0", customersitecode : this.customersiteCode, belowcardratefrom : "70", belowcardrateto : "79.99", commissionpercentage : "8", recordstatus : "MSC00001", recordstatuscode : "MSC00001",isdisabledremove:true},
    //         { bookingcommissionslabid : "0", customersitecode : this.customersiteCode, belowcardratefrom : "50", belowcardrateto : "69.99", commissionpercentage : "5", recordstatus : "MSC00001", recordstatuscode : "MSC00001",isdisabledremove:true},
    //         { bookingcommissionslabid : "0", customersitecode : this.customersiteCode, belowcardratefrom : "1", belowcardrateto : "49.99", commissionpercentage : "0", recordstatus : "MSC00001", recordstatuscode : "MSC00001",isdisabledremove:false}
    //       ]
          

    //     }
    //   }
    // }, error => { this._CustomExceptionService.handleError(error) }
    // );
  }
  ViewContractConversion(event){
    // console.log(event);
    this.router.navigate(['/cPrequotecontractconversion'], { state: { customersitecode: event.customersitecode} });
  }
  GoToCreate(event) {

    this.router.navigate(['/cPrequotecontractconversion']);

  }
  onBeforeUnload() {
    // debugger;
    alert("ok")
  }
}
